import {ReactComponent as Icon} from '@image/icon_home.svg';

const IconHome = () => {
    return   <Icon />;
};

export default IconHome;